import React from 'react';
import { useIntl } from 'react-intl';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel({ data, label, color, size }) {
  const intl = useIntl();
  const grey = (theme) => theme.palette.greys.darker;

  const labels = [
    <>
      <Typography
        noWrap
        variant="body1"
        color="textPrimary"
        sx={{
          fontWeight: 'bold',
        }}
      >
        {`${data?.value || 0} ${intl.messages.OF} ${data?.total || 0}`}
      </Typography>
      <Typography variant="caption" color="textPrimary">
        {intl.messages.PAID}
      </Typography>
    </>,
    <>
      <Typography noWrap variant="caption" sx={{ color: grey }}>
        {intl.messages.CALLED}
      </Typography>
      <Typography sx={{ color, fontSize: '1.5rem' }}>
        {data?.value || 0}
      </Typography>
    </>,
    <>
      <Typography noWrap variant="caption" sx={{ color: grey }}>
        {label}
      </Typography>
      <Typography sx={{ color, fontSize: '1.5rem' }}>
        {data?.value || 0}
      </Typography>
    </>,
  ];

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ position: 'relative' }}>
        <CircularProgress
          variant="determinate"
          sx={{ color: '#eeeeee', borderRadius: 5 }}
          style={{
            width: size,
            height: size,
          }}
          thickness={3}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          thickness={3}
          sx={{
            color,
            position: 'absolute',
            left: 0,
            borderRadius: 5,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
          value={
            (data?.value / data?.total) * 100 > 100
              ? 100
              : (data?.value / data?.total) * 100 || 0
          }
          style={{
            width: size,
            height: size,
          }}
        />
      </div>
      <Box
        sx={{
          position: "absolute",
          textAlign: "center"
        }}>
        {labels[typeof label === 'string' ? 2 : label]}
      </Box>
    </Box>
  );
}

const StyledCircularProgress = function StyledCircularProgress({
  progressData,
  color,
  label, // number indicates what label inside the progress to show
  size, //value to apply to width and height
}) {
  return (
    <CircularProgressWithLabel
      data={progressData}
      label={label}
      color={color}
      size={size}
    />
  );
};

export default StyledCircularProgress;
